module.exports = __webpack_public_path__ + "img/process1.683ae005.png";